const Footer = () => {
	return (
		<footer className="footer">
			<a
				href="https://github.com/psyjulga/React-Redux-project-employee-polls"
				target="_blank"
				rel="noreferrer"
				title="Code on Github"
			>
				Open-source code
			</a>
			🐞by Julia Bestgen💃
		</footer>
	)
}

export default Footer
